import React from 'react';
import ReactDOM from 'react-dom';
import Toaster from './toaster';

let type = 'normal';
let content = '';
let time = 5000;
const div = document.createElement('div');
document.body.appendChild(div);

function calls() {
  this.doToaster(type, content, time);
}
function create() {
  return (msg) => {
    type = msg.type ? msg.type : 'normal';
    content = msg.content ? msg.content : '';
    time = msg.time ? msg.time : 5000;
    ReactDOM.render(<Toaster />, div, calls);
  };
}

export default {
  toaster: create()
};



// WEBPACK FOOTER //
// ./src/Components/Toaster/index.js